import React from "react";
import PdfViewer from "../../PdfViewer";

const AnalisisRequerimientos = () => {
  const pdfUrl = `${process.env.REACT_APP_BUCKET}/pdf/03-analisis-de-requerimientos.pdf`;
  /*const pdfUrl = "/pdf/03-analisis-de-requerimientos.pdf";*/

  console.log("PDF URL:", pdfUrl);

  return (
    <>
      <main>
        <div class="titulo">
          <h1>Análisis de Requerimientos</h1>
        </div>
        <div className="pdf-container">
          <PdfViewer pdfUrl={pdfUrl} />
        </div>
      </main>
    </>
  );
};

 export default AnalisisRequerimientos;
